// extracted by mini-css-extract-plugin
export default {"inputbox":"TextInput_inputbox__apTT5","text":"TextInput_text__Nld20"};